// This icon file is generated automatically.
var PBellOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 16 16", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 12h-.38V6.69c0-2.2-1.62-4.03-3.74-4.33v-.61a.62.62 0 10-1.26 0v.6A4.37 4.37 0 003.63 6.7V12h-.37a.5.5 0 00-.5.5v.5c0 .07.06.13.13.13h3.37a1.75 1.75 0 003.5 0h3.38c.06 0 .12-.06.12-.13v-.5a.5.5 0 00-.5-.5zM8 13.88a.75.75 0 01-.75-.76h1.5c0 .42-.34.76-.75.76zM4.75 12V6.69A3.23 3.23 0 018 3.44a3.23 3.23 0 013.25 3.25V12h-6.5z", "fill-rule": "nonzero" } }] }, "name": "p-bell", "theme": "outlined" };
export default PBellOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBellOutlined.js
// module id = 3234
// module chunks = 0